<template>
    <div style="padding-top: 70px;height: 100vh;" class="main">
        <div v-if="ischange" >
            <div class="gg" v-if="isPC" >
                <el-row :gutter="50" style="padding-left: 20px" v-bind="$attrs">
                    <el-col :span="6" >
                        <div style="width: 300px;margin: 20px 0 0 0px;background-color: #7BA7C6;padding: 30px;float: right;">
                            <p style="font-size: 0.7em;color: white;margin-bottom: 1.5em">磁芯AI</p>
                            <el-input style="width: 200px" placeholder="请输入关键字" v-model="keywords"/>
                            <el-button @click="handleClick" > <i class="el-icon-search"></i>查找</el-button><br>
                            <hr style="color: white;margin: 10px 0"/>

                            <p style="font-size: 0.7em;line-height: 1.4em;margin-bottom: 1em">多条件批量搜索? 使用以下的恒创AI。</p>
                            <a @click="changes(false)" style="color: #fff;text-decoration: underline;cursor: pointer" size="medium">恒创AI >></a>


                        </div>
                    </el-col>

                    <el-col :span="18"  >

                            <div style="width:100%;height: 300px;overflow: hidden;background-color: rgb(241,241,241);text-align: center" v-if="pics">

                                <img :src="ImgPath" :alt="ProductName" :title="ProductName" style="height: 100%">
                                <span style="position: relative">
                                    <el-button style="position:absolute ;top:-270px;left: 20px" type="primary" size="small" @click="pics=false">关闭</el-button>
                                </span>
                            </div>

                    </el-col>

                </el-row>

            </div>
            <el-row :gutter="50">

            <el-col :span="6" v-show="isPC" style="text-align: center;overflow: scroll;" class="tac">
                <ul>

                    <li>
                        <p>{{title}}</p>
                    </li>
                    <li>
                        <el-menu
                                active-text-color="#ffd04b"
                                @select="handleSelect"
                                class="el-menu-vertical-demo"
                                :default-active="activeItem"

                        >
                            <el-sub-menu style="border: 1px solid #ccc;margin-top: 25px;background: #FFFAF0" v-for="(item,index) in types" :key="index+1" :index="index+1" >
                                <template #title style="font-weight: bold">{{item.name}}</template>
                                <el-menu-item style="color: #696969;font-weight: bold;"  @click="clickMenu(i)" v-for="(i,s) in types[index].arr" :key="i" :index="index+1+'-'+s">
                                    {{i.split(",id:")[0].split(",")[0].split(",")[0]}}
                                    <span v-show="false">{{i.split(",id:")[1]}}</span>
                                </el-menu-item>
                            </el-sub-menu>

                            <el-sub-menu style="border: 1px solid #ccc;margin:40px 0;">
                                <template #title style="font-weight: bold">材料专区</template>
                                <el-menu-item style="color: #696969;font-weight: bold"  @click="clickMate(item.catId)" v-for="(item,index) in solution">
                                    {{item.uniqueId}}
                                </el-menu-item>
                            </el-sub-menu>
                        </el-menu>
                    </li>
                </ul>



            </el-col>
            <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18" class="contain"  >

                <Page1 ref="page" :keyword="keywords" @changeMsg="changes" v-show="page1"/>
                <Page2 ref="page2" v-show="page2"/>


            </el-col>
        </el-row>

            <foot />
        </div>
        <div v-else>
            <Search  @changeMsg="changes"/>
        </div>

    </div>
</template>

<script>
    import request from "@/utils/request";
    import Page1 from "@/ZH-CN/calc/Page1";
    import Page2 from "@/ZH-CN/calc/Page2";
    import Search from "@/ZH-CN/forIfcores/search/search";
    import Foot from "@/ZH-CN/components/Foot";

    export default {
        name: "Products",
        components: {Foot, Search, Page1, Page2},
        metaInfo: {
            title: '产品中心 | 南京恒创磁电有限公司 - Powered by MeCMS', // set a title
            meta: [{
                // 设置meta信息
                name: '大功率铁氧体磁芯|大功率磁芯|软磁铁氧体磁芯|锰锌铁氧体磁芯|大尺寸磁芯|X光磁芯|高压变压器磁芯|微波铁氧体',
                content: '大功率磁芯,南京恒创磁电专业生产各种高品质大磁芯，大功率铁氧体磁芯，软磁铁氧体磁芯，锰锌铁氧体磁芯，大尺寸磁芯，X光磁芯，高压变压器磁芯，电话:18913981759'
            }]
        },
        data(){
            return{
                path:this.$route.path,//设置菜单高亮
                openeds:['1','2','3','4'],
                uniqueOpened:true,
                isPC:false,
                searchVal:"1",
                title:"产品分类",
                ischange:true,
                ischange2:false,
                types:[
                    {name:"铁氧体磁芯",arr:['EE',"UF"]},

                    ],
                activeItem:'',
                keywords:"",
                pics: false,
                ProductName:"",
                page1:true,
                page2:false,
                ImgPath:"",
                drawer2:false

            }
        },
        methods: {
            handleClick(){
                this.$refs.page.search2(1,this.keywords)
                this.page1=true
                this.page2=false
                sessionStorage.setItem("page1","true")
                sessionStorage.setItem("page2","false")
            },


            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
            clickMenu(i){

                this.ProductName=i.split(",id:")[0].split(",")[0]
                this.ImgPath=i.split(",id:")[0].split(",")[1]

                this.page1=true
                this.page2=false
                this.pics=true
                this.$refs.page.getData(1,i.split(',id:')[1])
                this.$refs.page.keywords="";

                sessionStorage.setItem("page1","true")
                sessionStorage.setItem("page2","false")
                sessionStorage.setItem("currentPage","")

                sessionStorage.setItem("keywords","")

            },
            clickMate(catId){
                sessionStorage.setItem("page1","false")
                sessionStorage.setItem("page2","true")
                this.page1=false
                this.page2=true
                this.$refs.page2.getData(catId)

            },
            changes(data){
                this.ischange=data
            },
            handleSelect(key){

                this.activeItem=key
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            }


        },



        beforeMount(){



            if (sessionStorage.getItem("page1")=="true"){
                this.page1= true
                this.page2= false
            }else if(sessionStorage.getItem("page2") =="true"){
                this.page1= false
                this.page2= true
            }else {
                this.page1=true;
                this.page2=false
            }
            if (this._isMobile()) {
                this.isPC=false;
            } else {
                // alert("pc端");
                // this.$router.replace('/test');
                this.isPC=true;
            }

            request.get("/productCategory/zh").then(res =>{
                this.types = res.data;
            }).catch((res)=>{
            })
            request.get("/solution").then(res =>{
                this.solution = res.data;
            }).catch((res)=>{
            })

        }

    }
</script>

<style scoped>


    .tac {
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        overflow-x: hidden;
        overflow-y: auto;
        padding-top: 50px;
    }
    .tac::-webkit-scrollbar {
        display: none; /* Chrome Safari */
    }
    .el-menu {
        border: 0 !important;


    }



    .tac p{
        margin-left: 20%;
        padding-bottom: 20px;
        border-bottom: 1px solid #ccc;
        text-align: left;
        color:#999;
        font-size: 14px;
        font-weight: bold;
    }


    div {
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        overflow-x: hidden;
        overflow-y: auto;
    }
    .tac >>>.el-menu-item:nth-child(2n){
        background: #ECF5FF;
        border-bottom: 1px solid #cccccc;
    }
    .tac >>>.el-menu-item:nth-child(2n+1){
        background: #ffffff;
        border-bottom: 1px solid #cccccc;

    }
    .tac >>>.el-menu-item:hover{
        background: #CDBE70;
        color: white;
    }


    >>>.el-sub-menu__title{
        font-weight: bolder;
        font-size: 15px;
    }
    .gg{

        background-image: url('../assets/1684911456523.jpg');
        height:300px
    }
    >>> .el-overlay{
        width: 25%;

    }
    >>> .el-drawer {

        width: 100%;
    }
</style>